export default __webpack_public_path__ + "static/media/Bank Info Illustration.f57af41f.svg";